export enum DashboardTab {
  DASHBOARD = 'dashboard',
  BDE = 'bde',
  MIB = 'mib'
}